export const resumeData = {
  name: "Abhirup Verma",
  tagline: "Advocate",
  photo: "https://customer-assets.emergentagent.com/job_ca394274-f8e2-41a4-a11a-fbec51912cdd/artifacts/wogiab4l_WhatsApp%20Image%202026-05-11%20at%2011.15.08%20PM.jpeg",
  specializations: ["Intellectual Property Law", "Corporate Law", "Sports Law"],
  contact: {
    email: "abhirupverma15@gmail.com",
    universityEmail: "21010126257@symlaw.ac.in",
    phone: "+91 8851409842",
    linkedin: "https://www.linkedin.com/in/abhirupverma/"
  },
  academics: [
    {
      year: "2021–2026",
      institution: "Symbiosis Law School, Pune",
      degree: "BBA LLB (Hons.)",
      details: "Latest GPA (Sem X): 7.90"
    },
    {
      year: "2021",
      institution: "Amity International School, Noida",
      degree: "Class XII (CBSE)",
      details: "89.4%"
    },
    {
      year: "2019",
      institution: "Amity International School, Noida",
      degree: "Class X (CBSE)",
      details: "92.4%"
    }
  ],
  internships: [
    {
      company: "Inttl Advocare",
      location: "Noida",
      duration: "September 2026",
      period: "Current",
      team: "",
      description: []
    },
    {
      company: "K&S Partners",
      location: "Gurugram",
      duration: "August 2026",
      period: "1 Month",
      team: "Trademarks, Copyrights and GI Team",
      description: [
        "Prepared replies to examination reports, summaries of recent trademark law judgments, and summaries of notices of opposition.",
        "Drafted user affidavits, cease-and-desist letters, and chances-of-success documents.",
        "Compiled existing evidence and found additional evidence available online for a client."
      ]
    },
    {
      company: "Fox Mandal and Associates",
      location: "Delhi",
      duration: "July 2026",
      period: "1 Month",
      team: "IP Team",
      description: [
        "Drafted replies to examination reports, opposition counter-statements, affidavits of evidence, rectification petitions, and cease and desist letters.",
        "Managed client and foreign associate correspondence on TM office actions, opposition/prosecution updates, and renewals.",
        "Filed trademark, design, and copyright applications.",
        "Researched stamp duty on TM assignment agreements across states."
      ]
    },
    {
      company: "Anand and Anand",
      location: "Noida",
      duration: "May 2026",
      period: "1 Month",
      team: "",
      description: [
        "Drafted litigation documents including a replication, cease and desist notice, and plaint contents; prepared summaries of infringement responses; researched and analysed case laws on personality rights, trademark assignment, transborder reputation spillover, Patents Act Sections 8 and 115, Order XI Rule 12 CPC, and the dominus litis principle in split trial jurisprudence."
      ]
    },
    {
      company: "Shardul Amarchand Mangaldas & Co.",
      location: "Delhi",
      duration: "April 2026",
      period: "1 Month (Call-Back)",
      team: "Trademarks Team",
      description: [
        "Trademark research including caselaw for refused marks, background checks on conflicting proprietors, lifecycle governance across ANZ, India, MENA, and SEA, and a trademark principles compendium.",
        "Litigation tasks included Section 447 Companies Act judgments, CPC procedural research, jurisdictional analysis for a Supreme Court SLP, court attendance at Delhi High Court, and civil procedure research."
      ]
    },
    {
      company: "Khurana and Khurana",
      location: "Greater Noida",
      duration: "February 2026",
      period: "1 Month",
      team: "Trademark Prosecution Team",
      description: [
        "Drafted trademark affidavits (Rules 45 & 46), Examination Report replies, and Notices of Opposition.",
        "Authored a legal blog on the recent LG Electronics judgment and compiled a 2025 Trade Mark Law judgment compendium.",
        "Published a blog titled \"Humour Versus Harm: A Review Of How The Trademark Act Deals With Parody And Infringement In India\" on Mondaq."
      ]
    },
    {
      company: "Krida Legal",
      location: "Delhi",
      duration: "November 2025",
      period: "1 Month",
      team: "Sports Law & Commercial Disputes",
      description: [
        "Worked on research and drafting in sports law, labour law, and commercial disputes including football relegation, CAS appellate jurisdiction, anti-doping matters, and High Court proceedings.",
        "Handled governance questions under the National Sports Governance Act, ISL commercial rights, office-bearer eligibility, and affiliation under IOA and NRAI frameworks.",
        "Corporate and regulatory work on private versus Section 8 companies, CSR utilisation, Overseas Direct Investment, and the Industrial Relations Code."
      ]
    },
    {
      company: "JSW Sports Pvt. Ltd.",
      location: "Remote",
      duration: "Sep–Oct 2025",
      period: "1.5 Months",
      team: "Legal",
      description: [
        "Drafted a note on a prominent football caselaw (Rahul Mehra vs Union of India) and a note on the impact of National Sports Governance Act, 2025.",
        "Worked on an RFP for upgradation, operation, maintenance and transfer of a sports facility in Mumbai (preparation of exhibits and PowerPoint presentation)."
      ]
    },
    {
      company: "LawNK Partners",
      location: "Bengaluru",
      duration: "August 2025",
      period: "5 Weeks",
      team: "Brand Protection & Sports",
      description: [
        "Drafted, amended, and proofread legal documents (agreements, policies, notices, memos, MoUs, and addenda).",
        "Conducted brand protection research (trademark searches, compliance checks, infringement monitoring, and reports) for professional sporting teams and charitable organizations."
      ]
    },
    {
      company: "Shardul Amarchand Mangaldas & Co.",
      location: "Delhi",
      duration: "July 2025",
      period: "3 Weeks",
      team: "Trademarks Team",
      description: [
        "Drafted various para-wise replies to Appeals and Injunction Applications (as part of rejoinder).",
        "Searched for various marks in the TM registry website and prepared a research note on changes in Nice Classification of TMs w.e.f 1st January 2026.",
        "Secured a call-back internship for April 2026."
      ]
    },
    {
      company: "AZB & Partners",
      location: "Noida",
      duration: "February 2025",
      period: "1 Month",
      team: "General Corporate",
      description: [
        "Conducted research and prepared notes; drafted and proofread legal documents relating to the SEBI Takeover Code, real estate laws, Companies Act 2013, LLP Act 2008, RBI guidelines, and various other statutes."
      ]
    },
    {
      company: "Adidas India Marketing Pvt. Ltd.",
      location: "Gurugram",
      duration: "January 2025",
      period: "1 Month",
      team: "Legal",
      description: [
        "Read and reviewed endorsement and sponsorship contracts with athletes, celebrities and sporting entities.",
        "Prepared presentations on EPF Act, 1952 & Payment of Gratuity Act, 1972 and researched Digital Personal Data Protection Rules 2025.",
        "Drafted legal notice for termination of lease, researched IBC 2016, consumer law, and maintained state-wise S&E/Trade/Advertisement licensing lists.",
        "Researched Legal Metrology Act provisions and maximum signage dimensions for Mumbai and Bengaluru."
      ]
    },
    {
      company: "LexOrbis IP Attorneys & Advocates",
      location: "New Delhi",
      duration: "August 2024",
      period: "1 Month",
      team: "Trademark Prosecution Team",
      description: [
        "Conducted trademark searches and drafted analysis reports, along with responses to examination reports and provisional refusals.",
        "Handled complex opposition evidence including Rule 45 para-wise replies and Rule 46 rejoinders.",
        "Attended hearings before the Registrar of Trademarks for Section 9 and 11 objections.",
        "Identified classes using WIPO Madrid Goods and Services Manager (MGS) and EUIPO website."
      ]
    },
    {
      company: "Sr. Adv. Mr. Dayan Krishnan",
      location: "New Delhi",
      duration: "Jan–Feb 2024",
      period: "5 Weeks",
      team: "Delhi High Court Practice",
      description: [
        "Read files and attended hearings in the Hon'ble Delhi High Court relating to Intellectual Property, Arbitration, Commercial Appellate, Criminal and Civil Writ Petitions.",
        "Researched and prepared notes on Arbitration, Injunctions against infringement of Trademarks, Copyrights and Patents.",
        "Drafted a note on changes in the new criminal laws vis-a-vis old criminal laws."
      ]
    },
    {
      company: "Nestle India Ltd.",
      location: "Gurugram",
      duration: "Jul–Aug 2023",
      period: "4 Weeks",
      team: "Indirect Tax Team",
      description: [
        "Drafted a position paper on whether sustainability-related work qualifies as CSR and whether the company can claim Input Tax Credit.",
        "Drafted an opinion on whether transfer of IP rights from an Indian to a foreign company constitutes a good or service under the IGST Act.",
        "Analyzed SC judgment in CC, CE and ST, Bangalore vs Northern Operating Systems Pvt. Ltd and presented analysis to the company's legal head."
      ]
    },
    {
      company: "S&A Law Offices",
      location: "New Delhi",
      duration: "February 2023",
      period: "2 Weeks",
      team: "Dispute Resolution",
      description: [
        "Researched Articles 226 and 227 of the Constitution, 'Public Policy of India' under Section 34 of the Arbitration Act 1996.",
        "Researched remedies for rejected applications under Order XI Rules 12 and 14, and scope of Section 37 of the Arbitration Act."
      ]
    },
    {
      company: "Dua Associates",
      location: "New Delhi",
      duration: "January 2023",
      period: "4 Weeks",
      team: "General Corporate",
      description: [
        "Researched stamp duty on physical share certificates across Maharashtra, West Bengal and Karnataka.",
        "Analyzed eligibility for UAV bidding under Buy (Indian-IDDM) category under Defence Acquisition Procedure, 2020.",
        "Drafted a feasibility analysis for a restaurant/cafe in South Delhi and amended Articles of Association for Companies Act 2013 compliance.",
        "Researched regulatory framework for foreign company acquiring an Indian company with land assets through FPIs."
      ]
    },
    {
      company: "Delhi High Court Legal Services Committee",
      location: "New Delhi",
      duration: "July 2022",
      period: "2.5 Weeks",
      team: "Legal Aid",
      description: [
        "Attended hearings in Civil and Criminal Legal Aid cases at Delhi High Court.",
        "Visited Tihar Jail and attended the legal aid cell for prisoners.",
        "Briefed on Pre-institution mediation under Section 12A of the Commercial Courts Act, 2015.",
        "Attended Pre-Lok Adalat sessions and Legal Aid Front Office duties."
      ]
    }
  ],
  coCurricular: [
    "Represented Symbiosis Law School, Pune in 5th IIT Law School National Moot Court Competition 2024 at RGSOIPL, IIT Kharagpur.",
    "Represented Symbiosis Law School, Pune in 2nd Amity National Trial Advocacy Tournament 2022."
  ],
  publications: [
    {
      title: "Humour Versus Harm: A Review Of How The Trademark Act Deals With Parody And Infringement In India",
      journal: "Mondaq",
      url: "https://www.mondaq.com/india/trademark/1756014/humour-versus-harm-a-review-of-how-the-trademark-act-deals-with-parody-and-infringement-in-india"
    },
    {
      title: "Types of Commercial Contracts in Indian Sports Landscape",
      journal: "Legal Service India E-Journal",
      url: "https://www.legalserviceindia.com/legal/article-18196-types-of-commercial-contracts-in-indian-sports-landscape-.html"
    },
    {
      title: "India's High-Stakes Gamble: Deconstructing The Promotion And Regulation Of Online Gaming Act, 2025",
      journal: "Legal Service India E-Journal",
      url: "https://www.legalserviceindia.com/Legal-Articles/indias-high-stakes-gamble-regulation-online-gaming-act-2025/"
    }
  ],
  certifications: [
    "Intellectual Property Law Course, University of Pennsylvania",
    "Patent Law Specialization Course, University of Pennsylvania",
    "Personal and Family Financial Planning Course, University of Florida",
    "Creative Thinking Course, Imperial College, London",
    "Fundamentals of Sports Marketing, Rajasthan Royals (Deakin University Australia)",
    "Fundamentals of Sports Law Course, The Legal Voice",
    "Cricket Analytics Workshop, Mad About Sports"
  ],
  positions: [
    "Captain, SLS Pune Cricket Team (2024–25 & 2025–26)",
    "Vice-Captain, Cricket Team, Symbiosis Law School, Pune",
    "Core-Committee Member, Sports Cell, Symbiosis Law School, Pune (2023–24)",
    "Co-headed Sports Budget Committee, Symbiosis Law School, Pune (2023–24)",
    "Event Head (IPL Auction), Sports Committee, Symbhav 2022 & 2023",
    "Captain, Amity International School, Noida Cricket Team — Junior (2015–17), Senior (2019–20)",
    "Team Strategist, National Sports Law Blueprint Advocacy Competition, 2025 (UPES Dehradun)"
  ],
  volunteering: [
    "Rights Protection Program Spotter (Volunteer) at Copyright Integrity International — Anti-Ambush marketing work during ICC Cricket World Cup 2023 matches at Pune.",
    "Volunteer, Sports Committee, Symbhav 2022 & 2024"
  ],
  extraCurricular: [
    "Runner-up in Under-14 School National Cricket Tournament (2015)",
    "Quarter Finalist at NLIU Bhopal Sports Fest (Virudhaka XIV) — Cricket",
    "Represented SLS Pune in BITS Goa Spree 2023 (Cricket), SIU Inter Institute Cricket Competition 2022 & 2024",
    "Represented Amity International School, Noida Cricket Team in various tournaments"
  ],
  personalDetails: {
    areasOfInterest: ["Intellectual Property Law", "Sports Law"],
    languages: ["Hindi", "English"]
  }
};
